const OVERLAY_SELECTOR = '.modal.show, .app-drawer[data-overlay-open="true"], .app-confirmation-modal[data-overlay-open="true"]';

const OverlayStack = {
    getOpenOverlays(excludeId = null) {
        const overlays = Array.from(document.querySelectorAll(OVERLAY_SELECTOR));

        if (!excludeId) {
            return overlays;
        }

        return overlays.filter((overlay) => overlay.id !== excludeId);
    },
    nextZIndex(excludeId = null) {
        return 1050 + (this.getOpenOverlays(excludeId).length * 20);
    },
    syncBodyState() {
        const hasOpenOverlay = this.getOpenOverlays().length > 0;

        $('html').css('overflow-y', hasOpenOverlay ? 'hidden' : 'auto');
        $('body').toggleClass('modal-open', hasOpenOverlay);
    },
};

export default OverlayStack;
